var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dr",
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ds",
    x1: 134.1,
    y1: 264.24,
    x2: 292.27,
    y2: 264.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4690ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4f2"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m283.34,258.99c-5.49-5.5-13.17-8.94-21.56-8.93-1.88,0-3.72.18-5.51.51-2.19-8.01-6.44-15.18-12.13-20.87-8.5-8.52-20.34-13.81-33.32-13.81-12.98,0-24.82,5.29-33.32,13.81-7.16,7.15-12.03,16.66-13.4,27.22-.88-.09-1.76-.13-2.66-.13-7.52,0-14.41,3.08-19.32,8.01-4.93,4.92-8.01,11.8-8.01,19.32,0,7.52,3.08,14.4,8.01,19.32,4.92,4.93,11.8,8.01,19.32,8.01,1.04,0,2.06-.07,3.06-.18l.08,1.33h95.51l-.28-1.62c.65.04,1.3.07,1.96.07,8.39,0,16.07-3.43,21.56-8.93,5.5-5.49,8.94-13.17,8.93-21.56,0-8.39-3.43-16.07-8.93-21.56Z",
    fill: "url(#ds)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m413.62,153.76c-.04-15.96-.07-29.55-.09-39.14-.01-4.8-.02-8.6-.02-11.2,0-2.6,0-4,0-4-.01-4.59-3.71-8.29-8.31-8.3l-243.18-.38-28.4-35.55c-1.58-1.97-3.96-3.12-6.49-3.13l-102.42-.16c-2.22,0-4.32.87-5.9,2.44-1.57,1.57-2.44,3.67-2.44,5.9l.59,308.82c0,4.59,3.71,8.3,8.31,8.3,0,0,1.38,0,3.97,0,38.87.06,350.64.55,375.01.59,4.59,0,8.32-3.71,8.33-8.3,0-4.59-3.71-8.32-8.31-8.33-25.99-.04-378.98-.59-378.98-.59v8.32s8.31-.02,8.31-.02l-.58-300.47,90.08.14,28.4,35.55c1.58,1.97,3.96,3.12,6.49,3.13l247.17.39v-8.32s-8.3.02-8.3.02c0,0,.05,22.42.12,54.34.01,4.59,3.74,8.31,8.34,8.3,4.59-.01,8.31-3.74,8.3-8.34h0Z",
    fill: "#f7f7f7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m33.24,368.59v-204.99h363.63v206.18c0,4.59,3.72,8.32,8.32,8.32s8.32-3.72,8.32-8.32v-214.49c0-2.19-.89-4.33-2.44-5.88s-3.69-2.44-5.88-2.44H24.92c-2.19,0-4.33.89-5.88,2.44-1.55,1.55-2.44,3.69-2.44,5.88v213.31c0,4.59,3.72,8.32,8.32,8.32s8.32-3.72,8.32-8.32h0Z",
    fill: "#f7f7f7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderCloud);
export default __webpack_public_path__ + "static/media/folder_cloud.6937999110ca57124bdf34e983b24d62.svg";
export { ForwardRef as ReactComponent };